var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusiveProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0417 0H13.9583C6.26171 0 0 6.26171 0 13.9583V53.0417C0 60.7383 6.26171 67 13.9583 67H53.0417C60.7383 67 67 60.7383 67 53.0417V13.9583C67 6.26171 60.7383 0 53.0417 0ZM38.2917 47.4583C38.2917 48.9993 36.041 50.25 34.5 50.25C32.959 50.25 30.7083 48.9993 30.7083 47.4583V27.2808L28.6509 29.3382C27.5593 30.4298 25.795 30.4298 24.7035 29.3382C23.6119 28.2467 23.6119 25.4823 24.7035 24.3908L31.5263 17.568C32.3247 16.7695 34.5195 16.5295 35.5692 16.9622C36.6133 17.3949 38.2917 18.4138 38.2917 19.5417V47.4583Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveProvider);
export default __webpack_public_path__ + "static/media/exclusiveProvider.2c61f22b904ef8077f0d9889e3394179.svg";
export { ForwardRef as ReactComponent };